import { render, staticRenderFns } from "./CertificationForm.vue?vue&type=template&id=f9107a08&scoped=true&"
import script from "./CertificationForm.vue?vue&type=script&lang=ts&"
export * from "./CertificationForm.vue?vue&type=script&lang=ts&"
import style0 from "./CertificationForm.vue?vue&type=style&index=0&id=f9107a08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9107a08",
  null
  
)

export default component.exports